import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const ButtonComponent = ({
  className,
  styles,
  children,
  variant,
  theme,
  disabled,
  onClick,
  ...rest
}) => (
  <button
    className={classnames(
      className,
      'nmx-button',
      `nmx-button--${variant}`,
      { 'nmx-button--disabled': disabled },
      { [theme]: !!theme },
    )}
    disabled={disabled}
    style={styles || {}}
    onClick={onClick}
    {...rest}>
    {children}
  </button>
);

ButtonComponent.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  /** Text to place in the button */
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quarternary']).isRequired,
  theme: PropTypes.oneOf(['nmx-pcg']),
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

ButtonComponent.defaultProps = {
  className: null,
  styles: null,
  children: '',
  variant: 'primary',
  disabled: false,
};

export default ButtonComponent;
